/*============================================================================
  ___  _   _    _
 /   || | | |  | |
 \__  | | | |  | |  __
 /    |/  |/_) |/  /  \_/\/
 \___/|__/| \_/|__/\__/  /\_/
               |\
               |/

  Help @ Elkfox.com
  https://elkfox.com
  https://experts.shopify.com/elkfox
  Copyright 2015 Shopify Inc. & Elkfox Co Pty Ltd
  Author Carson Shold @cshold & Team Elkfox @elkfox

==============================================================================*/

/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);
    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'), // TO DO

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      preOrder = options.preOrder,
      preOrderCart = options.preOrderCart,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText'),
      $preOrderText = $('#PreOrderText');

      console.log(preOrder)
      console.log(preOrderCart)

  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available && preOrder == false ) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add To Cart");
      $quantityElements.show();
    } else if (variant.available && preOrder == true ) {
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Preorder");
      $quantityElements.show();
      if (preOrderCart) {
        $preOrderText.html('Please note: pre-order items need to be purchased seperately from other items.');
      } else if (preOrderCart == null) {
        $preOrderText.html('Please note: pre-order items need to be purchased seperately from other items.');
      } else if (preOrderCart == false) {
        $preOrderText.html('Your cart currently contains items that are not pre-order. <a href="/cart">Click here</a> to complete your order for these items or remove these items from your cart.');
      }
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat).replace(".00", "")  );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
      .html( ' From ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {

    // cd code (Back Order text change in cart drawer)
    $('.ajaxcart__product-meta').each(function(index, element){
      if($(element).text().trim() == 'Order Back order'){
        $(element).text('Back order');
      }
    });
    
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();



/*============================================================================
  #Social Sharing
==============================================================================*/

window.timberSocial = window.timberSocial || {};

timberSocial.cacheSelectors = function () {
  timberSocial.cache = {
    $shareButtons: $('.social-sharing'),
  }
};

timberSocial.init = function () {
  timberSocial.cacheSelectors();
  timberSocial.sliders();
};

timberSocial.socialSharing = function () {

  timberSocial.cacheSelectors();

  // General selectors
  var $buttons = timberSocial.cache.$shareButtons,
      $shareLinks = $buttons.find('a'),
      permalink = $buttons.attr('data-permalink');

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var el = $(this),
        popup = el.attr('class').replace('-','_'),
        link = el.attr('href'),
        w = 720,
        h = 720;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        w = 480;
        h = 320;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }
    window.open(link, popup, 'width=' + w + ', height=' + h);
  });
}


/*============================================================================
  #Initialize
==============================================================================*/

// Initialize Timber's JS on docready
$(timber.init);

// Initialize social sharing

  $(timberSocial.socialSharing)


/*============================================================================
  #Slick Slider
==============================================================================*/

if($('.slick-slider').length && $('.template-product').length == 0){
    $(document).ready(function(){
    $('.slick-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true
    });
  });
}


/*============================================================================
  #Mega Menu
==============================================================================*/
$(function(){
  $('.overlay-close').click(function() {
    $('.overlay').removeClass ('overlay-open');
    $('#PageContainer').removeClass ('shrink-page');
  });
});
// show the overlay
$(function(){
  $(".overlay-toggle").on("click", function(event){
    event.preventDefault();
    $('.overlay').addClass ('overlay-open');
    $('#PageContainer').addClass ('shrink-page');
  });
});

/*============================================================================
  #Search toggle
==============================================================================*/
$(function(){
  $('.site-header .search-toggle').click(function() {
    if ($('.site-header .search').hasClass("search-hidden")) {
      $('.site-header .search input').trigger("select");
      $('.site-header .search input').val('');
    }
    $('.site-header .search').toggleClass('search-hidden');
  });
});
$(function(){
  $('.nav-bar .search-toggle').click(function() {
    if ($('.nav-bar .search').hasClass("search-hidden")) {
      $('.nav-bar .search input').trigger("select");
      $('.nav-bar .search input').val('');
    }
    $('.nav-bar .search').toggleClass('search-hidden');
  });
});
/*============================================================================
  #Smooth Scrolling for back to top commented because it's buggy

$('a').click(function(){
    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 1000);
    return false;
});
==============================================================================*/
/*============================================================================
  #Product Page Accordion
==============================================================================*/
$(function(){});
$(document).on('click', '.accordion', function() {
  // remove classes from all siblings
  $(this).siblings().removeClass('active');
  $(this).siblings().removeClass('show');

  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).next().removeClass('show');
  }else{
    $(this).addClass('active');
    $(this).next().addClass('show');
    }
});

/*============================================================================
  #Fix Header
==============================================================================*/
$.resizeContentHeight = function() {
  $('.main-content').css("margin-top", $(".header-fixed").outerHeight());
}

$.fixHeader = function() {
  var winTop = $(window).scrollTop();
  var header = $(".site-header").outerHeight();
  if(winTop >= header){
      $("nav.nav-bar").addClass("header-fixed");
      $.resizeContentHeight();
  }else{
      $("nav.nav-bar").removeClass("header-fixed");
      $("nav.nav-bar .search").addClass("search-hidden");
      $('.main-content').css("margin-top", "0px");
  }
}


$.mobileHeader = function() {
  var width = $(window).width()
  if( width < 820 ) {
    $(".site-header").addClass('mobile');
    //$('.main-content').css("margin-top", $(".site-header").outerHeight()); //CD
  } else {
    $(".site-header").removeClass('mobile');
    $.fixHeader();
  }
}

/*============================================================================
  #Endless scrolling
==============================================================================*/
$.endlessScroll = function() {
  if ($("#endless:last-child .more").length){
    var bottom = $(".main-content").outerHeight()
    var docTop = ($(document).scrollTop() + ($(window).height() + 2000) );
    if( docTop > bottom ) {
    	$.loadMore();
    }
  }
}

$.loadMore = function() {
  var scrollURL = $('#endless:last-child .more p a').last().attr("href");
  $("#endless:last-child").addClass("has-more");
  $.ajax({
    type: 'GET',
    dataType: 'html',
    url: scrollURL,
    beforeSend: function() {
      $(document).off('scroll');
      $('#endless:last-child .more p a').fadeIn( "fast" );
    },
    success: function(data) {
      var filteredData = $(data).find("#endless:last-child");
      $('#endless:last-child .more p a').fadeOut( "fast" );
      filteredData.appendTo( $("#endless").parent() ).hide().fadeIn( "slow" );
      $(document).on( "scroll", function() {
        $.endlessScroll();
      });
    }
  });
}

//CD [manage space]
function manage_space(top_bar = true) {
  if($(".site_header").length) {
    var top_space = $(".site_header").outerHeight();
    if($('.announcement-wrap').length && top_bar) top_space = top_space+$('.announcement-wrap').outerHeight();
    $(':root').get(0).style.setProperty('--mobile-top-space',top_space+'px');
  }
}

/*============================================================================
  #detect changes
==============================================================================*/
// Scroll
$(document).on( "scroll", function() {
  $.endlessScroll();
});
$(window).scroll(function() {
  $.mobileHeader();
});
// Load
$(window).load(function() {
  $.mobileHeader();
});
// Resize
$(window).resize(function() {
  $.mobileHeader();
  manage_space(); //CD
});


// CD

$(document).ready(function(){
  setTimeout(function(){ $(".newsletter_popup").addClass("newsletter_open"); }, 10000);
  manage_space(); //CD
});

$(document).on("click",".model_close",function(){
	$(".newsletter_popup").removeClass("newsletter_open");
});

$(document).ready(function(){
  if (window.location.href.indexOf('?customer_posted=true') > 0) {
    if($(".popup_content_inner").length){
      $(".popup_content_inner").addClass("thank_you_open");
      var uri = window.location.toString();
      if (uri.indexOf("?") > 0) {
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        window.history.replaceState({}, document.title, clean_uri);
      }
    }
  }

  if($('.marquee_content').length){
    if($('.site_header').length || $('.marquee_content')) $('.site_header').get(0).style.setProperty('--header-top-space',$('.marquee_content').outerHeight()+'px');
  }
  // if($('.announce_slider').length) {
  //   $('.announce_slider').on('init',function(){
  //     if($('.site_header').length) $('.site_header').get(0).style.setProperty('--header-top-space',$('.announcement-wrap').outerHeight()+'px');
  //   });
    
  //   $('.announce_slider').slick({
  //     autoplay: true,
  //     arrows: false,
  //     fade: true
  //   });
  // }
  
  $('.btn_ann_close').on('click',function(){
    $(this).parents('.announcement-wrap').slideUp();
    if($('.site_header').length) $('.site_header').get(0).style.setProperty('--header-top-space',0);
    if($('.mobile_menu_drawer').length) $('.mobile_menu_drawer').get(0).style.setProperty('--mobile-menu-top',($('.site_header').height())+'px');
    $('#shopify-section-offer-bar').get(0).style.setProperty('--mobile-menu-top',($('.site_header').height())+'px');
    manage_space(false);
    
    // CD CODE 
    setCookie("announcement banner","yes", 30);
    $("#shopify-section-announcement-bar").hide();
  });
});

$(document).ready(function(){
  	if($('.mobile_menu_drawer').length) $('.mobile_menu_drawer').get(0).style.setProperty('--mobile-menu-top',($('.site_header').height() + $('.announcement-wrap').outerHeight() - 15)+'px');
    
});

if($('.template-product').length){
  $(window).scroll(function(){
    if($('.mobile_menu_drawer').length) $('.mobile_menu_drawer').get(0).style.setProperty('--mobile-menu-top',($('.site_header').height())+'px');
  });
}

// cd jaydip

// $(document).on("click",".nav_bar_edit .child_menu",function(){
//   if($(this).parents('.site_nav_li').hasClass('open_megamenu')){
//     $('.site_nav_li').removeClass('open_megamenu')
//   }else{
//     $('.site_nav_li').removeClass('open_megamenu')
//     $(this).parents('.site_nav_li').addClass('open_megamenu')
//   }
// });


$(document).on("click",".js_mobile_drawer",function(){
	$("body").toggleClass("drawer_menu_open");
});

$(document).on("click",".js_submenu_open, .js_sub_menu_close",function(e){
  $(this).parents(".main_menu").toggleClass("child_menu_open");
  $(this).parents("ul.nav").toggleClass("submenu_open");
});

$(document).on("click",".js_child_submenu",function(e){
  if($(this).parents(".nav__item_submenu").hasClass("sub_child_menu_open")){
    $(this).parents(".nav__item_submenu").removeClass("sub_child_menu_open").find('.child_menu').slideUp();
  }else{
    $(".nav__item_submenu").removeClass("sub_child_menu_open").find('.child_menu').slideUp();
    $(this).parents(".nav__item_submenu").addClass("sub_child_menu_open").find('.child_menu').slideDown();
  }
});


// CD CODE

$(window).on('load' ,function(e){
  $('#shopify-section-announcement-bar .announcement-wrap').css('visibility', 'visible')
});



$(document).ready(function(){
  checkCookie()
});

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user=getCookie("announcement banner");
  if (user != "") {
    $("#shopify-section-announcement-bar").hide();
    $('body').addClass('hide_announcement-bar');
  }
}

$(document).on('click', '.search_page .search-toggle', function(){
  if($(this).parent('.search_page').find('.search').hasClass('search-hidden')){
    $(this).parent('.search_page').find('.search').removeClass('search-hidden');
    $('.mobile_menu_drawer .search_page .search .search-bar [type="search"]').focus();
  }else{
    $(this).parent('.search_page').find('.search').addClass('search-hidden');
  }
});

// cd jaydip

// load-more

// $('[js-load-more]').on('click', function(){
//   var $this = $(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
//   $this.attr('disabled', true);
//   $this.find('[load-more-text]').addClass('hide');
//   $this.find('[loader]').removeClass('hide');
//   currentPage = currentPage+1;
//   var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
//   $('[data-current-page]').val(currentPage);
//   $.ajax({
//     url: nextUrl,
//     type: 'GET',
//     dataType: 'html',
//     success: function(responseHTML){
//       $('.grid__item .grid-uniform').append($(responseHTML).find('.grid__item .grid-uniform').html());
//     },
//     complete: function() {
//       if(currentPage >= totalPages) {
//         $this.remove();
//       }
//       else {
//         $this.attr('disabled', false);
//         $this.find('[load-more-text]').removeClass('hide');
//         $this.find('[loader]').addClass('hide');
//       }
//     }
//   })
// });

// search bar

$(document).on("click",".site_header_change .search_icon",function() {
  $(this).parents('.site_header_change .search-bar').addClass('open_search_bar');
});
$(document).on("click",".site_header_change .close_icon",function() {
  $(this).parents('.site_header_change .search-bar').removeClass("open_search_bar");
});

// sort by

$(document).on("click",".collection_tag_filter .select_button",function(e){
  $(this).parents(".collection_tag_filter .custom_select").toggleClass("open_select");
});

$(document).on("click", function(e) {
  if(!$('.collection_tag_filter .select_button').has(e.target).length){
    $('.collection_tag_filter .custom_select').removeClass("open_select");
  }
});

if($(".collection_tag_filter .custom_select").length){
  var sort_select = $('.sort_by li[selected] a').text();
  // if(sort_select == 'Best selling'){
    $('.custom_select .sort_btn_text').text('SORT')
  // }else
  // {
  //   $('.custom_select .sort_btn_text').text(sort_select)
  // }
}


// filter popup

// $(document).on("click",".collection_tag_filter .filter_text",function() {
//   $(this).parents('.collection_tag_filter .facets__wrapper').addClass('open_filter_popup');
// });
// $(document).on("click",".collection_tag_filter .filter_popup_close .filter_close",function() {
//   $(this).parents('.collection_tag_filter .facets__wrapper').removeClass("open_filter_popup");
// });


// $(document).on( "click", ".collection_tag_filter .filter_form .filter-group-display .filter-group-display__list label", function() {
//   $(this).parents( ".collection_tag_filter .filter_form .filter-group-display" ).find( ".filter-group-display__submit input" ).trigger( "click" );
// });


// $(document).on("change", ".collection_tag_filter .filter-form .filter-group .filter-group-display__price-range-from input", function(){
//   $(this).parents(".filter-form .filter-group-display__price-range").find(".filter-group-display__price-range-to .js-qty input").val()

//   if($(this).parents(".filter-form .filter-group-display__price-range").find(".filter-group-display__price-range-to .js-qty input").val()){

//     $(this).parents( ".collection_tag_filter .filter_form .filter-group-display" ).find( ".filter-group-display__submit input").trigger( "click" );

//   }
// });

// $(document).on("change", ".collection_tag_filter .filter-form .filter-group .filter-group-display__price-range-to input", function(){
//   $(this).parents(".filter-form .filter-group-display__price-range").find(".filter-group-display__price-range-from .js-qty input").val()

//   if($(this).parents(".filter-form .filter-group-display__price-range").find(".filter-group-display__price-range-from .js-qty input").val()){

//     $(this).parents( ".collection_tag_filter .filter_form .filter-group-display" ).find( ".filter-group-display__submit input").trigger( "click" );
//   }
// });

// you may also like

function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}




// age check 
$(document).on('submit', '.popup_newsletter .contact-form',function( event ) {

  setCookie("newsletter","yes", 30);
  $(".newsletter_popup").hide();

});
$(document).on('click','.newsletter_popup .model_close', function(event) {
  event.preventDefault();
  //Check it the user has been accpeted the agreement

  setCookie("newsletter","yes", 30);
  $(".newsletter_popup").hide();
});

$(document).ready(function(){
  checkCookie()
});

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*60*60*7*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user=getCookie("newsletter");
  if (user != "") {
    $(".newsletter_popup").hide();
  }
}


$(document).on('click','.collection_tag_filter .sort_by li', function(event) {
  event.preventDefault()
  if (window.location.href.indexOf("?q=") > -1) {
    var url = window.location.href;  
    var arr = url.split('?')[1];
    var split_url = arr.split('&')[0];
    var get_link = ($(this).find("a").attr("href").replace("?", "&"));
    var join_url = url.split('?')[0] + '?' + split_url + get_link;

    window.location.replace(join_url);
  }
  else{
    window.location.href = $(this).find("a").attr("href");
  }
});


// cd code
$(document).on('click', '.cust_read_more_desc', function(){
  if($(".cust_read_more_desc").hasClass('desc_open')){
    $(this).removeClass('desc_open');
    $(this).text("Read More"); 
    $('.custom_pro_description').css('maxHeight', '100px');
    $('.cust_read_more_dots').css('display', 'block');
  }else{
    $(this).addClass('desc_open');
    $('.custom_pro_description').css('maxHeight', 'unset');
    $('.cust_read_more_dots').css('display', 'none');
    $(this).text("Read Less");
  }
});

$(document).ready(function(){
  var pro_desk_height = $('.custom_pro_description').height();
  
  if(pro_desk_height < 100){
    $('.cust_read_more').addClass('cust_hide');
  }
});

// CD CODE
$(document).on('click', '.estimated_delivery .information_icon svg', function(){
  if($(this).parents('.estimated_delivery').find('.more_info_delivery').hasClass('is_message_open')){
    $(this).parents('.estimated_delivery').find('.more_info_delivery').removeClass('is_message_open');
  }else{
    $(this).parents('.estimated_delivery').find('.more_info_delivery').addClass('is_message_open');
  }
});

$(document).on("click", function(e) {
  if($('.more_info_delivery').length && $(e.target).is(".information_icon svg") === false && $(e.target).is(".information_icon") === false){
    $('.more_info_delivery').removeClass('is_message_open');
  }
});

// cd code
$(document).ready(function(){
  $('.product-description-change .accordion').each(function(index, element) {
    if($(element).text().trim() == 'Shipping + Returns'){
      $(element).addClass('custom_hide_arrow');
    }
  });
});

$(document).on('click', '.grid_item_change .product-desc .new_atc_btn', function(){
  $(this).parents('.grid_item_change').find('.js_ATC_btn').click();
});

// CD Sanket
$(document).on('click', '.js_search_toggle', function(){
  $('.js_hide_show').addClass('show_container');
  $('body').addClass('page_lock');
  setTimeout(function() {
    $(".js_search_input").focus();
  }, 100);
});
$(document).on('click', '.header_search_bar_close', function(){
  $('.header_search_bar').val('');
  $('#header-search-contaniner').html('');
});
$(document).on('click', '.search_container_close', function(){
  $('.js_hide_show').removeClass('show_container');
  $('body').removeClass('page_lock');
});


$(document).on('input', '.js_search_input', function(){
  var search_val = $(this).val().replace(/ /g, '+');
  $.ajax({
    url: '/search?q='+ search_val +'&view=alternative',
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $("#header-search-contaniner").html(responseHTML);
      if($('.header-search-btn_link').length){
        $('.header-search-btn_link a').attr('href', '/search?q='+ search_val +'');
      }
    },
    complete: function(){
      isInProgress = false;
    }
  });
  
});

$(".js_search_input").keydown(function (e) {
  var search_val = $(this).val().replace(/ /g, '+');
  if (search_val != ""){
    if (e.keyCode == 13) {
      window.location.replace('/search?q='+ search_val +'');
    }
  }
});

$(".variant-dropdown-menu h5").click(function(){
    $(this).toggleClass('open');
  $(".variant-dropdown-menu .variant-dropdown-menu-hide").slideToggle("slow");
});

$('.variant-dropdown-menu-selected-option').on('click', function() {
  var data_index = parseInt($(this).parents('.variant-dropdown-menu-select-box').attr('data-index'));
  $('.variant-dropdown-menu-select-box.active:not([data-index="' + data_index + '"])').find('.variant-dropdown-menu-listoptions-list').slideUp();
  $('.variant-dropdown-menu-select-box.active:not([data-index="' + data_index + '"])').removeClass('active');
  $(this).parents('.variant-dropdown-menu-select-box').toggleClass('active');
  $(this).parents('.variant-dropdown-menu-select-box').find('.variant-dropdown-menu-listoptions-list').slideToggle();
});

$('.variant-dropdown-menu-listoptions-list li').on('click', function() {
    var $parents = $(this).parents('.variant-dropdown-menu-select-box');
    var data_index = $parents.attr('data-index');
    // $('.selector-wrapper:nth-child(' + data_index + ') .single-option-selector').val($(this).text());
    $('.selector-wrapper:nth-child(' + data_index + ') .single-option-selector option').val($(this).text()).trigger('change');
    $parents.find('.variant-dropdown-menu-selected-option').text($(this).text());
    $parents.removeClass('active');
    $(this).parents('.variant-dropdown-menu-listoptions-list').find('li').removeClass('selected');
    $(this).addClass('selected');
    $parents.find('.variant-dropdown-menu-listoptions-list').css('display', 'none');

    if($('#productSelect-option-0').length){
      document.querySelector('#productSelect-option-0').value = $(this).attr('value');
      document.querySelector('#productSelect-option-0').dispatchEvent(new Event('change', { bubbles: true }));
    }
});

$('.pro-grid-variant-selected-option').on('click', function() {
  $(this).parents('.pro-grid-variant-select-box').toggleClass('active');
  $(this).parents('.pro-grid-variant-select-box').find('.pro-grid-variant-dropdown-menu').slideToggle();
});

$('.pro-grid-variant-dropdown-menu li').on('click', function() {
    var $parents = $(this).parents('.pro-grid-variant-select-box');
    $(this).parents('.pro_grid_select_hide').find('select').val($(this).attr('value')).trigger('change');
    $parents.find('.pro-grid-variant-selected-option').text($(this).text());
    $parents.removeClass('active');
    $('.pro-grid-variant-dropdown-menu li').removeClass('selected');
    $(this).addClass('selected');
    $parents.find('.pro-grid-variant-dropdown-menu').css('display', 'none');
});

document.addEventListener('contextmenu', function(event) {
    if (event.target.closest('.img-wrapper').querySelector('[id="ProductPhotoImg"]')) {
      event.preventDefault();
    }
  });

// $(document).bind("contextmenu",function(e){
//   return false;
// });

// CD shubham
var header_height = $('.site_header').height();
if($('.announcement-wrap').length && !$('.template-product').length){
  header_height = $('.site_header').height() + $('.announcement-wrap').height();
}
if($('.marquee_content').length && !$('.template-product').length){
  header_height = $('.site_header').height() + $('.marquee_content').height();
}
$('#shopify-section-offer-bar').get(0).style.setProperty('--mobile-menu-top',header_height+'px');


// if($(".product_slider").length){
//   $(".product_slider").slick({
//     slidesToShow: 1,
//     autoplay: true,
//     dots: true,
//     arrows: false,
//     adaptiveHeight: false
//   });
// }


$(document).ready(function() {
  $('.template-product #AddToCart').removeAttr('disabled');
});



// $(document).on('click', '.delivery-options input', function(){
//   if($('.delivery-options input:checked').length == 2){
//     $('#CartDrawer [type="submit"]').prop('disabled', false);
//   }else{
//     $('#CartDrawer [type="submit"]').prop('disabled', true);
//   }
// })

$(document).ready(function () {

    function updateCheckoutButton() {
        const checkedCount = $('.delivery-options input:checked').length;

        if (checkedCount > 0) {
            $('#CartDrawer [type="submit"]').prop('disabled', false);
        } else {
            $('#CartDrawer [type="submit"]').prop('disabled', true);
        }
    }

    updateCheckoutButton();

    $(document).on('change', '.delivery-options input', function () {
        updateCheckoutButton();
    });

});